import { combineReducers } from "redux";

export const programsByID = (state = {}, action) => {
  switch (action.type) {
    case "SET_PROGRAMS": {
      const nextState = { ...state };
      nextState[action.programs.donation_id] = action.programs;
      return nextState;
    }
    default:
      return state;
  }
};

export const programsError = (state = null, action) => {
  switch (action.type) {
    case "SET_PROGRAMS_ERROR":
      return action.message;
    default:
      return state;
  }
};

export const programsLoading = (state = false, action) => {
  switch (action.type) {
    case "SET_PROGRAMS_LOADING":
      return true;
    case "SET_PROGRAMS":
    case "SET_PROGRAMS_LOAD_COMPLETED":
    case "SET_PROGRAMS_ERROR":
      return false;
    default:
      return state;
  }
};

export const selectedID = (state = null, action) => {
  switch (action.type) {
    case "SET_SELECTED_PROGRAM":
      return action.id;
    default:
      return state;
  }
};

export const programSaving = (state = null, action) => {
  switch (action.type) {
    case "SET_PROGRAM_EDIT_SAVING":
      return true;
    case "SET_PROGRAM_EDIT_ERROR":
    case "SET_PROGRAM_EDIT_SUCCESS":
    case "SET_PROGRAM_EDIT_DONE":
      return false;
    default:
      return state;
  }
};

export const programSuccess = (state = null, action) => {
  switch (action.type) {
    case "SET_PROGRAM_EDIT_SUCCESS":
      return action.message;
    case "SET_PROGRAM_EDIT_ERROR":
    case "SET_PROGRAM_EDIT_SAVING":
    case "SET_PROGRAM_EDIT_DONE":
      return false;
    default:
      return state;
  }
};

export const programError = (state = null, action) => {
  switch (action.type) {
    case "SET_PROGRAM_EDIT_ERROR":
      return action.message;
    case "SET_PROGRAM_EDIT_SAVING":
    case "SET_PROGRAM_EDIT_SUCCESS":
      return false;
    default:
      return state;
  }
};

export const programDone = (state = null, action) => {
  switch (action.type) {
    case "SET_PROGRAM_EDIT_DONE":
      return true;
    case "SET_PROGRAM_EDIT_SAVING":
    case "SET_PROGRAM_EDIT_SUCCESS":
    case "SET_PROGRAM_EDIT_ERROR":
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  programsByID,
  programsError,
  programsLoading,
  selectedID,
  programSaving,
  programSuccess,
  programError,
  programDone,
});

export const getSelectedProgramID = (state) => state.selectedID;
export const getPrograms = (state) => Object.values(state.programsByID);
export const getProgramsLoading = (state) => state.programsLoading;
export const getProgramsError = (state) => state.programsError;
export const getSelectedProgram = (state) =>
  state.selectedID in state.programsByID
    ? state.programsByID[state.selectedID]
    : null;
export const getProgramSaving = (state) => state.programSaving;
export const getProgramSuccess = (state) => state.programSuccess;
export const getProgramError = (state) => state.programError;
export const getProgramDone = (state) => state.programDone;
export const getProgramsByPaymentType = (state, paymentType) =>
  getPrograms(state).filter((program) => program.payment_type === paymentType);
